var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tab_"},_vm._l((_vm.quotationData.labelContents),function(item,index){return _c('span',{key:index + 'tab',class:{ on: index == _vm.nowTabIndex },on:{"click":function($event){return _vm.changeTab(item, index)}}},[_vm._v(_vm._s(item.contentTitle))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }